import styled, { css } from 'styled-components'
import {
  flexDirection,
  FlexDirectionProps,
  margin,
  MarginProps,
  width,
  WidthProps,
} from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'
import { HEADER_HEIGHT_PX } from 'Constants/Navigation'

type CardProps = WidthProps & {
  sticky?: boolean
}

const shouldForwardProp = (prop: string) =>
  ![...DIV_SHOULD_FORWARD_PROP, 'sticky'].includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  max-width: ${LANDING_CONTENT_WIDTH_PX}px;
  gap: ${themeGet('space.9')}px;

  ${flexDirection}
`

const cardStickyCss = ({ sticky }: CardProps) =>
  sticky &&
  css`
    position: sticky;
    top: calc(${HEADER_HEIGHT_PX.DESKTOP}px + ${themeGet('space.6')}px);
  `

export const Card = styled.div.withConfig({
  shouldForwardProp,
})<CardProps>`
  display: flex;
  padding: ${themeGet('space.9')}px;
  border-radius: 20px;
  background-color: ${themeGet('colors.background.screen')};

  ${width}

  ${cardStickyCss}
`

export const Divider = styled.div.withConfig({
  shouldForwardProp,
})<MarginProps>`
  width: 100%;
  height: 1px;
  background-color: ${themeGet('colors.line.tertiary')};

  ${margin}
`
